<template>
  <v-main class="main-pane">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page.sync="itemPerPage"
      :options.sync="pagination"
      :page.sync="currentPage"
      :expanded.sync="expanded"
      :server-items-length="totalItems"
      :footer-props="footer_props"
      :no-data-text="$t('label.nodata')"
      show-expand
      multi-sort
      item-key="idx"
      class="elevation-1 table-fluid idcs-pane-back px-4"
      :sort-by="'idx'"
      :sort-desc="true"
    >
      <template v-slot:progress>
        <div class="progress-container">
          <v-progress-circular :size="100" :width="7" color="green" indeterminate></v-progress-circular>
        </div>
      </template>
      <template v-slot:top>
        <v-row class="ml-0" align="top">
          <v-col cols="12" md="4">
            <date-picker
              v-model="dates"
              range
              confirm
              clearable
              @confirm="newRange"
              :shortcuts="shortcuts"
              :lang="$i18n.locale"
              :input-class="'idcs-data-pick'"
              class="idcs-picker-wrap"
            ></date-picker>
          </v-col>
          <v-col cols="12" md="1" lg="2"></v-col>
          <v-col cols="6" md="4" lg="4">
            <v-select
              :label="$t('ticket.status_l')"
              :items="$t('ticket.status')"
              v-model="filter.status"
              background-color="yellow lighten-5"
              color="black"
              dense
              shaped
              outlined
              multiple
              @change="loadData"
              :placeholder="$t('ticket.status_ph')"
            />
          </v-col>
          <v-col cols="6" md="3" lg="2">
            <v-text-field
              :label="$t('ticket.search_l')"
              v-model="pattern"
              background-color="yellow lighten-5"
              color="black"
              dense
              shaped
              clearable
              outlined
              append-icon="mdi-magnify"
              @click:append="searchReload(false)"
              @keydown.enter="searchReload(false)"
              @keydown.escape="searchReload(true)"
              @click:clear="searchReload(true)"
              :placeholder="$t('ticket.search')"
            />
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="{headers, item, isExpanded, expand}">
        <tr :class="(item.pos%2==0?'idcs-data-back':'idcs-data-back2')">
          <template v-for="h in headers">
            <td v-if="h.value=='created'" :key="h.value">{{item.created | dt-sec}}</td>
            <td v-else-if="h.value=='actions'" :key="h.value">
              <v-btn
                v-if="$store.getters.test('tickets.u') && item.status==0 && item.sender==$store.getters['user/name']"
                icon
                @click.prevent="record={...item}, d_showRecord=true"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="$store.getters.test('tickets.a') && (item.status==1 || item.status==2)"
                icon
                @click.prevent="record={...item}, d_showRecord=true"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
            <td
              v-else-if="h.value=='typeid'"
              :key="h.value"
            >{{$t("ticket.types")[item.typeid].text}}</td>
            <td
              v-else-if="h.value=='status'"
              :key="h.value"
              :class="'text-center text-uppercase font-weigth-bold status-'+item.status"
            >{{$t("ticket.status")[item.status].text}}</td>
            <td v-else-if="h.value=='data-table-expand'" :key="h.value">
              <v-btn
                v-if="($store.getters.test('tickets.a') || item.sender==$store.getters['user/name']) && item.resume"
                x-small
                icon
                @click="expand(!isExpanded)"
                :color="!isExpanded?'blue lighten-2':'blue lighten-4'"
              >
                <v-icon>{{isExpanded?'fa-angle-double-up':'fa-angle-double-down'}}</v-icon>
              </v-btn>
            </td>
            <td v-else :key="h.value" :align="h.align">{{item[h.value]}}</td>
          </template>
        </tr>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length" class="detail-row">
          <v-row>
            <v-col cols="12" v-if="item.resume">
              <v-icon class="mr-4">mdi-message-reply-text-outline</v-icon>
              <span>{{item.resume}}</span>
            </v-col>
          </v-row>
        </td>
      </template>
      <template v-slot:footer>
        <v-btn
          v-if="$store.getters.test('tickets.u')"
          absolute
          fab
          color="pink"
          @click="record={typeid: 0}, d_showRecord=true"
          dark
          class="mt-n2 ml-2"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <TicketRecord v-model="d_showRecord" :record="record" @refresh="loadData" />
  </v-main>
</template>

<script>
import app from "@/app.js";
import commonTables from "@/mixins/tables_common.js";
import TicketRecord from "@/components/editTypes/TicketRecord.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/lv.js";
import "vue2-datepicker/locale/ru.js";
import moment from "moment";

export default {
  mixins: [commonTables],
  components: { DatePicker, TicketRecord },
  name: "Tickets",
  data() {
    return {
      dates: [moment().subtract(7, "day").startOf("day").toDate(), new Date()],
      record: {},
      pattern: null,
      expanded: [],
      d_showRecord: false,
      headers: [
        {
          text: "",
          align: "center",
          value: "actions",
          sortable: false,
          width: 70,
        },
        {
          text: "#",
          align: "center",
          value: "idx",
          sortable: true,
          width: 80,
        },
        {
          text: this.$t("ticket.domain"),
          align: "center",
          value: "domain",
          width: 100,
          sortable: true,
        },
        {
          text: this.$t("ticket.sender"),
          align: "center",
          width: 100,
          value: "sender",
        },
        {
          text: this.$t("ticket.description"),
          align: "left",
          value: "description",
          width: "55%",
          sortable: false,
        },
        {
          text: this.$t("field.created"),
          align: "center",
          value: "created",
          width: 200,
          sortable: true,
        },
        {
          text: this.$t("ticket.closedat"),
          align: "center",
          width: 200,
          value: "closedat",
          sortable: true,
        },
        {
          text: this.$t("field.status"),
          align: "center",
          value: "status",
          sortable: true,
        },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  watch: {
    dates: {
      handler() {
        this.currentPage = 1;
        this.loadData();
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  computed: {},
  mounted() {
    // this.dates.sd = moment().subtract(7, "day").startOf("day").toDate();
    // this.dates.ed = moment().endOf("day").toDate();
    if (this.$store.getters.test("tickets.u")) {
      this.headers.splice(2, 1);
    }
  },
  methods: {
    searchReload(clear) {
      if (!clear && !this.pattern) return;
      if (clear) this.pattern = null;
      this.filter.search = this.pattern;
      this.loadData();
    },
    loadData() {
      this.items.splice(0, this.items.length);
      this.loading = true;
      const params = {};
      if (this.dates[0] == null) this.dates[0] = new Date();
      if (this.dates[1] == null) this.dates[1] = new Date();
      params.sd = this.$moment(this.dates[0]).format("YYYYMMDD");
      params.ed = this.$moment(this.dates[1]).format("YYYYMMDD");
      app
        .getTickets({
          sortBy: this.pagination.sortBy,
          sortDesc: this.pagination.sortDesc,
          filter: { ...this.filter, ...params },
          limit: this.pagination.itemsPerPage,
          offset: (this.pagination.page - 1) * this.pagination.itemsPerPage,
        })
        .then((r) => {
          this.loading = false;
          this.totalItems = r.count;
          this.items = r.items;
          this.expanded.splice(0, this.expanded.length);
          const isAdmin = this.$store.getters.test("tickets.a");
          const user = this.$store.getters["user/name"];
          this.items.forEach((e) => {
            if ((isAdmin || e.sender == user) && e.resume) {
              this.expanded.push(e);
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-pane {
  width: 100%;
  height: 100%;
}
.progress-container {
  width: 100%;
  text-align: center;
  padding: 20px;
}
.table-fluid {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.filter-pane {
  border-radius: 25px;
}
.dialog-content {
  font-family: monospace;
  white-space: pre;
  font-size: 20px;
}
.detail-row {
  background-color: ghostwhite;
}
.status-0 {
  background-color: lightgray;
  letter-spacing: 2px;
}
.status-1 {
  background-color: lightblue;
  letter-spacing: 2px;
}
.status-2 {
  background-color: lightgreen;
  letter-spacing: 2px;
}
.status-3 {
  background-color: green;
  color: white;
  letter-spacing: 2px;
}
.status-4 {
  background-color: red;
  color: white;
  letter-spacing: 2px;
}
</style>